import {
  GraphQLID,
  GraphQLObjectType,
  GraphQLInputObjectType,
  GraphQLNonNull
} from 'graphql'
import { ReactionOperation, reactionOperationType } from './reaction-operation'

export interface CustomMetadataSettings {
  readonly newAppAction: ReactionOperation
  readonly existingAppAction: ReactionOperation
}

export const CustomMetadataSettingsType = new GraphQLObjectType({
  name: 'CustomMetadataSettings',
  description: 'Custom metadata settings required for the Organization',
  fields: () => ({
    newAppAction: {
      description: 'Restrict on missing required fields to new Apps only',
      type: new GraphQLNonNull(reactionOperationType)
    },
    existingAppAction: {
      description: 'Restrict on missing required fields to existing Apps only',
      type: new GraphQLNonNull(reactionOperationType)
    }
  })
})

export interface CustomMetadataSettingsArgs {
  readonly input: {
    readonly organizationID: string
  }
}

export const customMetadataSettingsArgType = new GraphQLInputObjectType({
  name: 'CustomMetadataSettingsArgType',
  fields: () => ({
    organizationID: {
      description: 'Organization ID',
      type: new GraphQLNonNull(GraphQLID)
    }
  })
})

export const customMetadataSettingsArgs = {
  input: {
    type: customMetadataSettingsArgType
  }
}
